import { render, staticRenderFns } from "./Patting.vue?vue&type=template&id=272a88fe&scoped=true"
import script from "./Patting.vue?vue&type=script&lang=js"
export * from "./Patting.vue?vue&type=script&lang=js"
import style0 from "./Patting.vue?vue&type=style&index=0&id=272a88fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a88fe",
  null
  
)

export default component.exports